import * as React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button } from '@mui/material';
import { RaRecord, useRecordContext, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const CloneProcessTemplateButton = ({ record: recordProp }: { record?: RaRecord }) => {

  const translate = useTranslate();
  const navigate = useNavigate();
  const contextRecord = useRecordContext();
  const record = recordProp || contextRecord;

  if (!record) return null;

  return (
    <Button
      size="small"
      startIcon={<ContentCopyIcon />}
      onClick={(event) => {

        event.stopPropagation();
        navigate(`/process-templates/create?cloneFrom=${record.id}`);

      }}
    >
      {translate('resources.process-templates.text.clone', { _: 'Clone' })}
    </Button>
  );

};
